import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'expenses',
    lazy: async () => ({ Component: (await import('./ExpensesPage')).ExpensesPage }),
  },
];
